const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const apiUrl = (path) => `${BASE}${path}`;
